<footer class="footer_wrap clearfix">
  <!-- Commenting it because should be part of different ticket
  <div class="footer_wrap--gameprovider clearfix">
    <div class="payment-types">
      <div class="container-fluid">
        <div class="col-sm-12">
          <ul class="games_logo_list">
            <li>
              <img alt="" class="img-responsive desktop-img" src="{{siteUrlPath}}/{{mediaPath}}/game-providers.png">
              <img alt="" class="img-responsive mobile-img" src="{{siteUrlPath}}/{{mediaPath}}/game-providers-mobile.png"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  -->
  <div class="footer_language">
    <div class="overlay" *ngIf="viewLang"></div>
    <div class="language-selection-wrap">
      <button #langSelect class="select-lang-box" (click)="viewLang = !viewLang">
        <span class="lang-country-flag">
          <img [attr.src]="'/assets/country_flags/'+langCode+'.svg'" />
        </span>
      <span class="lang-country-lang">{{langCode | countryName | translate}}</span>
        <i class="icon icon-dropdown-arrow"></i>
      </button>
      <ul class="select-lang-dropdown footer-lang-dropdown" [ngClass]="viewLang ? 'show' : 'hide'">
          <li [ngClass]="{'active': langCode === lang}" [value]="lang" *ngFor="let lang of mappedLanguageCodes">
            <a href="{{'/'+lang}}" (click)="listClick($event, lang)">
              <span class="lang-country-flag">
                <img [attr.src]="'/assets/country_flags/'+lang+'.svg'" />
              </span>
              <span class="lang-country-text">{{ lang | countryName}}</span>
            </a>
          </li>
      </ul>
    </div>
    <div class="footer_chat show-below-992" *ngIf="isZendeskEnabled"><a href="javascript:void(0)" (click)="toggleZDChat()"><i class="icon-chat"></i> Live Chat</a></div>
    <div class="footer_chat show-below-992" *ngIf="isTudiChatEnabled"><a href="javascript:void(0)" (click)="toggleTugiChat()"><i class="icon-chat"></i> Live Chat</a></div>
  </div>
  
  <app-static-pages [url]="'footer'"></app-static-pages>
  <app-static-pages *ngIf="jurisdictionVal" [url]="'footer-licence-' + jurisdictionVal"></app-static-pages>


  <!-- Footer Copyrights and Lang Dropdown section -->
  <div class="container-fluid footer_wrap--bottom-wrap">

    

    <app-shotfooter></app-shotfooter>
  </div>

</footer>

<!-- Footer Set Cookie bar  -->
<div class="cookie-fixed-bar">
  <div class="cookie-fixed-bar-bg clearfix" *ngIf="cookieClose">
    <div class="cookie-body">
      <h5>{{'footerComp.cookieHeader' | translate}}</h5>
      <!-- <p><span class="show-below-992">{{'footerComp.readthe' | translate}}</span>
        <span class="hide-below-992">{{'footerComp.cookiePolicyPopup' | translate}}</span>
        <a routerLink="{{langCode+'/page/cookie-policy'}}">{{'footerComp.cookiePolicy' | translate}}</a>
      </p> -->
    </div>
    <button (click)="cookieFixedBar()" class="cookie-policy-save">{{'footerComp.ok' | translate}}</button>
    <!-- <span (click)="cookieFixedBar()" class="cookie-policy-save hide-below-992">{{'footerComp.cookieAgree' | translate}}</span> -->
  </div>
</div>

<ng-container *ngIf="isShowTransactionNotification">
  <div class="deposit-success-notification">
    <p><span style="padding-right: 10px;">{{transactionNotification?.amount | currencyPipe:1}}</span>{{transactionNotification?.message}} </p>
  </div>
</ng-container>